// extracted by mini-css-extract-plugin
export default {"AboutContainer":"About_AboutContainer__fkykv","AboutImg":"About_AboutImg__Vtqux","AboutDescription":"About_AboutDescription__atnX0"};